import React, { useEffect, useState, useCallback } from 'react';
import './AnalysisModal.css';
import { FaTimes } from 'react-icons/fa';
import { LoadingGeminiState, EmptyState } from './LoadingGeminiStates';

function AnalysisModal({ item, onClose, currentTime }) {
    const [isLoading, setIsLoading] = useState(false);
    const [analysisResult, setAnalysisResult] = useState(null);

    const fetchAnalysis = useCallback(async () => {
        setIsLoading(true);
        try {
            // const response = await fetch('http://localhost:5000/api/rss/analyze', {
            const response = await fetch('/.netlify/functions/analyze', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ title: item.title, link: item.link }),
            });

            const data = await response.json();
            setAnalysisResult(data.analysis);
        } catch (error) {
            console.error('Error fetching analysis:', error);
            setAnalysisResult(null);
        } finally {
            setIsLoading(false);
        }
    }, [item.title, item.link]);

    useEffect(() => {
        fetchAnalysis();
    }, [fetchAnalysis]);

    // Function to render the analysis content based on format
    const renderAnalysisContent = () => {
        if (typeof analysisResult === 'string') {
            // Check if the result is HTML formatted
            if (analysisResult.includes('<') && analysisResult.includes('>')) {
                return <div dangerouslySetInnerHTML={{ __html: analysisResult }} />;
            }

            // For plain text, preserve line breaks
            return (
                <div className="plain-text-analysis">
                    {analysisResult.split('\n').map((line, i) => (
                        <p key={i}>{line}</p>
                    ))}
                </div>
            );
        }

        // For JSON or object format
        if (typeof analysisResult === 'object' && analysisResult !== null) {
            return (
                <div className="structured-analysis">
                    {Object.entries(analysisResult).map(([key, value], i) => (
                        <div key={i} className="analysis-section">
                            <h3 className="section-title">{key}</h3>
                            <div className="section-content">
                                {typeof value === 'string' ?
                                    value.split('\n').map((line, j) => <p key={j}>{line}</p>) :
                                    JSON.stringify(value)
                                }
                            </div>
                        </div>
                    ))}
                </div>
            );
        }

        return <p>No analysis available</p>;
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <div className="article-title-container">
                        <h2 className="article-title">{item.title}</h2>
                    </div>
                    <button className="close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>
                <div className="content-container">
                    {isLoading ? (
                        <LoadingGeminiState />
                    ) : analysisResult ? (
                        <div className="analysis-result-container">
                            <div className="url-container">
                                <p><strong>🔗 URL:</strong> <a href={item.link} target="_blank" rel="noopener noreferrer" className="truncated-url">{item.link}</a></p>
                            </div>
                            <div className="analysis-content">
                                {renderAnalysisContent()}
                            </div>
                        </div>
                    ) : (
                        <EmptyState />
                    )}
                </div>
            </div>
        </div>
    );
}

export default AnalysisModal;